import { States } from '@eigtech/function-utils';
import { RoofPitchSchema, TimeOfServiceSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { MechanicalTypeSchema } from './cost.js';
export const EmsTarpingDetailsSchema = z.object({
    isMultiStory: z.boolean(),
    mechanicalType: MechanicalTypeSchema,
    roofPitch: RoofPitchSchema,
    serviceDate: z.iso.datetime().optional(),
    state: States.UsStatesAbbreviatedSchema,
    tarpSquareFeet: z.number(),
    timeOfService: TimeOfServiceSchema,
});
